export default __webpack_public_path__ + "static/media/298.89d4bf7d.png";